// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"help"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.9957 16.4502V15.0715C11.9957 13.3983 13.4915 12.1047 14.8057 11.0692C15.8619 10.2371 16.54 8.94656 16.54 7.49766C16.54 4.98792 14.5054 2.95337 11.9957 2.95337C10.0171 2.95337 8.3338 4.2179 7.70996 5.98289M11.9955 19.9941H12.0014","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HelpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'help',
    ref,
    icon: element,
  },
));

HelpIcon.displayName = 'HelpIcon';

export default HelpIcon;
